var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 360 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 355L132.45 323.464V355H0ZM156.9 247.479L135.45 306.645L21.75 231.711L156.9 247.479ZM165.45 232.612L84.3 123.289L205.95 184.408L165.45 232.612ZM219 173.445L180 42.9484L273.45 142.06L219 173.445ZM289.5 136.053L297.45 0L351.45 125.091L289.5 136.053ZM360 163.835V355H169.05C169.05 249.431 254.55 163.835 360 163.835Z",
    fill: "#007DA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSun);
export default __webpack_public_path__ + "static/media/BlueSun.413b97f5631984a7def7f179402dd24c.svg";
export { ForwardRef as ReactComponent };